// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e889764","455":"dfc7d834","488":"a289eb4f"}[chunkId] + ".chunk.js";
};